import { createContext } from "react";

export const ArchivedProjectsSocketContext = createContext(null);